import * as React from 'react';
import styled from 'styled-components';
import * as bp from 'view/styles/breakpoints';
import * as grid from 'view/styles/grid';
import * as zIndex from 'view/styles/z-index';
import { SpotlightCard } from '@atlaskit/onboarding';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const SPOTLIGHT_CARD_WIDTH = grid.multiple(40.75).unitless;
// eslint-disable-next-line rulesdir/no-styled-export
export const FixedSpotlightContainer = styled.div`
    display: none;
    ${bp.fromXSmall.css`
        display:block;
        position: fixed;
        bottom: ${token('space.200', '16px')};
        width: ${SPOTLIGHT_CARD_WIDTH}px;
        right: ${token('space.200', '16px')};
        z-index: ${zIndex.modal};
    `};
    ${bp.fromXLarge.css`
        position: absolute;
        width: ${SPOTLIGHT_CARD_WIDTH}px;
        top: -${grid.multiple(3).px};
        right: -${SPOTLIGHT_CARD_WIDTH + grid.multiple(5.5).unitless}px;
    `};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const EditButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

// make sure dismiss button is using white color
// eslint-disable-next-line rulesdir/no-styled-export
export const DismissWrapper = styled.span`
    color: ${token('color.text.inverse', colors.N0)};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const StyledSpotlightCard = styled((props: Omit<ExtractProps<typeof SpotlightCard>, 'theme'>) => (
    <SpotlightCard {...props} />
))`
    border-top-left-radius: 0;
    border-top-right-radius: 0;
`;
